export default __webpack_public_path__ + "static/Blind-angels-dazon-profile-3d202e5562cb63930391be25a4c523d5.png";